import React from "react";
import {Route, Switch} from "react-router-dom";
import Home from "./Containers/Home";
import Login from "./Containers/Login";
import Signup from "./Containers/Signup";
import Materias from "./Containers/Materias";
import Apoyo from "./Containers/Apoyo";
import Biblioteca from "./Containers/Biblioteca";
import Imagenes from "./Containers/Imagenes";
import Simuladores from "./Containers/Simuladores";
import About from "./Containers/About";
import Privacy from "./Containers/Privacy";
import NotFound from "./Containers/NotFound";
import Contenido from "./Containers/Contenido";
import Exam from "./Containers/Exam";
import Anuncios from "./Containers/Anuncios";
import Calificaciones from "./Containers/Calificaciones";
import Soporte from "./Containers/Soporte";
import Foro from "./Containers/Foro";

export default function Routes() {
    return (
        <Switch>
            <Route exact path="/">
                <Home/>
            </Route>
            <Route exact path="/login">
                <Login/>
            </Route>
            <Route exact path="/signup">
                <Signup/>
            </Route>
            <Route exact path="/materias">
                <Materias/>
            </Route>
            <Route exact path="/calificaciones">
                <Calificaciones/>
            </Route>
            <Route exact path="/soporte">
                <Soporte/>
            </Route>
            <Route exact path="/foros">
                <Foro/>
            </Route>
            <Route exact path="/anuncios">
                <Anuncios />
            </Route>
            <Route exact path="/apoyo">
                <Apoyo/>
            </Route>
            <Route exact path="/biblioteca">
                <Biblioteca/>
            </Route>
            <Route exact path="/imagenes">
                <Imagenes/>
            </Route>
            <Route exact path="/simuladores">
                <Simuladores/>
            </Route>
            <Route exact path="/about">
                <About/>
            </Route>
            <Route exact path="/privacidad">
                <Privacy/>
            </Route>
            <Route exact path="/materias/:major/:id" render={(props) => <Contenido {...props} />}/>
            <Route exact path="/exam/:id">
                <Exam/>
            </Route>
            {/* Finally, catch all unmatched routes */}
            <Route>
                <NotFound/>
            </Route>
        </Switch>
    );
};